import { render, staticRenderFns } from "./ViewTransferReceipt.vue?vue&type=template&id=dd32c598&scoped=true&"
import script from "./ViewTransferReceipt.vue?vue&type=script&lang=js&"
export * from "./ViewTransferReceipt.vue?vue&type=script&lang=js&"
import style0 from "./ViewTransferReceipt.vue?vue&type=style&index=0&id=dd32c598&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd32c598",
  null
  
)

export default component.exports